import { useState, useEffect } from "react";

const TOKEN_KEY = "buergerportal_token";

/**
 * Passwort-Gate fürs Bürgerportal (Nutzeranforderung: 'den Bürger-Teil
 * möchte ich auch per Passwort gesichert haben'). Bewusst OHNE den
 * zentralen api-Client (der einen normalen Auth-Header mitschicken würde) -
 * das Bürgerportal-Token ist ein eigenständiger, geringerer Zugangsnachweis,
 * kein vollwertiger Benutzer-Login.
 *
 * Prüft zuerst /oeffentlich/geschuetzt (immer ohne Token abrufbar) - ist
 * kein Passwort konfiguriert, wird der Inhalt direkt gezeigt, exakt wie
 * vor diesem Feature.
 */
export default function BuergerPortalGate({ children }) {
  const [geschuetzt, setGeschuetzt] = useState(null);
  const [hatZugang, setHatZugang] = useState(!!localStorage.getItem(TOKEN_KEY));
  const [passwort, setPasswort] = useState("");
  const [fehler, setFehler] = useState("");
  const [lädt, setLädt] = useState(false);

  useEffect(() => {
    fetch("/api/oeffentlich/geschuetzt").then(r => r.json()).then(d => setGeschuetzt(d.geschuetzt));
  }, []);

  const anmelden = async (e) => {
    e.preventDefault();
    setFehler("");
    setLädt(true);
    try {
      const r = await fetch("/api/oeffentlich/login", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ passwort }),
      });
      if (!r.ok) {
        setFehler("Zugangscode falsch.");
        return;
      }
      const { token } = await r.json();
      localStorage.setItem(TOKEN_KEY, token);
      setHatZugang(true);
    } catch {
      setFehler("Verbindung fehlgeschlagen.");
    } finally {
      setLädt(false);
    }
  };

  if (geschuetzt === null) return null;
  if (!geschuetzt || hatZugang) return children;

  return (
    <div style={{ maxWidth: 360, margin: "80px auto", padding: 24 }}>
      <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>Zugangscode erforderlich</h1>
      <div style={{ fontSize: 13, color: "#666", marginBottom: 20 }}>
        Dieses Bürgerportal ist mit einem Zugangscode geschützt.
      </div>
      <form onSubmit={anmelden}>
        <input type="password" className="form-control" placeholder="Zugangscode" value={passwort}
          onChange={e => setPasswort(e.target.value)} autoFocus style={{ marginBottom: 12 }} />
        {fehler && <div style={{ color: "var(--danger)", fontSize: 13, marginBottom: 12 }}>{fehler}</div>}
        <button className="btn btn-primary" type="submit" disabled={lädt} style={{ width: "100%" }}>
          {lädt ? "Wird geprüft…" : "Zugang bestätigen"}
        </button>
      </form>
    </div>
  );
}

/** Liefert den Authorization-Header fürs Bürgerportal-Token, falls vorhanden -
 * von den Bürgerportal-Seiten selbst beim fetch() mitzuschicken. */
export function buergerportalAuthHeader() {
  const token = localStorage.getItem(TOKEN_KEY);
  return token ? { Authorization: `Bearer ${token}` } : {};
}
